const PropTypes = require('prop-types');
const React = require('react');
const { actions: ShippingLabelActions } = require('./shipping_label_form_module');
const Tooltip = require('components/tooltip');
const PriceFieldWithCurrency = require('components/shared/price_field_with_currency');
const debounce = require('components/shared/debounce');
const TYPING_DELAY = 300; // ms

class OrderCustoms extends React.Component {
  constructor() {
    super();
    this.updateOrderDeclaredValue = this.updateOrderDeclaredValue.bind(this);
  }

  get tarrifNumberDescription() {
    return `${this.props.order.tariffNumber} (${this.props.order.categoryName})`;
  }

  updateOrderDeclaredValue(event) {
    const cents = this.dollarsUSDToCents(event.target.value);
    ShippingLabelActions.updateOrderDeclaredValue(this.orderId, cents);
  }

  dollarsUSDToCents(dollarsString) {
    const cents = parseFloat(dollarsString) || 0;
    return cents * 100;
  }

  get orderId() {
    return this.props.order.id;
  }

  countryOptionsForSelect() {
    return (
      this.props.originCountries.map((country) =>
        <option
          key={country.country_code}
          value={country.country_code}
        >
          {country.name}
        </option>
      )
    );
  }

  fieldName(field) {
    return `shipping_label_form[customs_info][orders][][${field}]`;
  }

  render() {
    return (
      <div>
        <hr className="mtb-1"></hr>
        <h4 className="heading-4 scaling-mb-half">
          {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.customsForOrder', { orderId: this.orderId })}
        </h4>
        <div className="g-container" key={this.orderId}>
          <div className="g-col-6 g-col-mobile-12">
            <input
              name={this.fieldName('id')}
              type="hidden"
              value={this.orderId}
            />
            <strong>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.quantity')}
            </strong>
            <p
              id={`${this.orderId}-quantity`}
              className="scaling-mb-half"
            >
              {this.props.order.quantity}
            </p>
            <strong>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.tariffNumber')}
            </strong>
            <p
              className="scaling-mb-half"
              id={`${this.orderId}-tarrifNumber`}
            >
              {this.tarrifNumberDescription}
            </p>
            <strong>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.contentType')}
            </strong>
            <p className="scaling-mb-half">
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.merchandise')}
            </p>
            <strong>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.restrictionType')}
            </strong>
            <p className="scaling-mb-half">
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.none')}
            </p>
            <strong>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.nonDeliveryOption')}
              <Tooltip
                className="ml-half"
                title={I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.nonDeliveryTooltipHtml', { lineBreak: '<br>' })}
              />
            </strong>
            <p className="scaling-mb-half">
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.returnToSender')}
            </p>
          </div>
          <div className="g-col-6 g-col-mobile-12 mobile-mt-half">
            <label>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.description')}
            </label>
            <div className="input text required">
              <textarea
                className="text required wide required"
                required="required"
                name={this.fieldName('description')}
                defaultValue={this.props.order.customsDescription}
              >
              </textarea>
            </div>
            <label>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.declaredValue')}
            </label>
            <div className="prepend-icon-wrapper append-currency-wrapper">
              <span className="prepend-icon">
                <span className="fa fa-usd">
                </span>
              </span>
              <div className="input string required">
                <PriceFieldWithCurrency
                  showCurrencyCode
                  currency="USD"
                  required
                  defaultValue={this.props.order.insurableAmountUSDDollars}
                  onChange={debounce(this.updateOrderDeclaredValue, TYPING_DELAY)}
                  name={this.fieldName('declared_value')}
                />
              </div>
            </div>
            <label>
              {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.countryOfOrigin')}
              <Tooltip
                className="ml-half mr-half"
                title={I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.originCountryTooltip')}
              />
              <span className="hint">
                {I18n.t('js.dashboard.selling.shippingLabels.orderCustoms.whereItWasMade')}
              </span>
            </label>
            <select
              defaultValue={this.props.order.defaultCountryOfOrigin}
              type="text"
              className="wide required nochosen"
              name={this.fieldName('country_of_origin')}
            >
              {this.countryOptionsForSelect()}
            </select>
          </div>
        </div>
      </div>
    );
  }
}

OrderCustoms.propTypes = {
  order: PropTypes.object.isRequired,
  originCountries: PropTypes.array.isRequired,
};

module.exports = OrderCustoms;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/order_customs.jsx